import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const partApi = createApi({
  reducerPath: 'partApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Part', 'PartPromo'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
